import { useContext } from 'react';

import { CampaignFormContext } from 'pages/campaigns/campaignForm/campaignForm.context';
import { CampaignFormStepThreeProvider } from './campaignFormStepThree.context';
import BeautyCampaignFormStepThree from './components/beautyCampaignFormStepThree/beautyCampaignFormStepThree';
import FashionCampaignFormStepThree from './components/fashionCampaignFormStepThree/fashionCampaignFormStepThree';

const CampaignFormStepThree = () => {
  const { brand } = useContext(CampaignFormContext);

  return (
    <CampaignFormStepThreeProvider>
      <div className="flex flex-col gap-[60px] pt-[56px]">
        {brand.isCategoryBeauty ? <BeautyCampaignFormStepThree /> : <FashionCampaignFormStepThree />}
      </div>
    </CampaignFormStepThreeProvider>
  );
};

export default CampaignFormStepThree;
